import { render, staticRenderFns } from "./reserveOrderDet.vue?vue&type=template&id=589eef02&scoped=true"
import script from "./reserveOrderDet.vue?vue&type=script&lang=js"
export * from "./reserveOrderDet.vue?vue&type=script&lang=js"
import style0 from "./reserveOrderDet.vue?vue&type=style&index=0&id=589eef02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589eef02",
  null
  
)

export default component.exports